export default __webpack_public_path__ + "images/stripe-payment-element/discover-c6b81334dc4b36a8700571305b3851ee.svg";